
export default {
  noData: '目前沒有資料',
  termsAndConditions: '條款及細則',
  privacy: '私隱政策',
  upload: '上傳',
}

